module.exports = __webpack_public_path__ + "img/cbd.f705fb95.png";